import { render, staticRenderFns } from "./watchlist.vue?vue&type=template&id=b73605e4&scoped=true&"
import script from "./watchlist.vue?vue&type=script&lang=js&"
export * from "./watchlist.vue?vue&type=script&lang=js&"
import style0 from "./watchlist.vue?vue&type=style&index=0&id=b73605e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73605e4",
  null
  
)

export default component.exports